import { Language } from '../types/language';

export class AppError extends Error {
  constructor(
    message: string,
    public code: string,
    public userMessage: { en: string; fr: string }
  ) {
    super(message);
    this.name = 'AppError';
  }

  getLocalizedMessage(language: Language): string {
    return this.userMessage[language];
  }
}

export const ErrorCodes = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  FIREBASE_ERROR: 'FIREBASE_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
} as const;

export function createError(code: keyof typeof ErrorCodes, details?: unknown): AppError {
  const errorMessages = {
    VALIDATION_ERROR: {
      en: 'Please check your input and try again.',
      fr: 'Veuillez vérifier vos données et réessayer.'
    },
    FIREBASE_ERROR: {
      en: 'Failed to save your data. Please try again.',
      fr: 'Échec de la sauvegarde de vos données. Veuillez réessayer.'
    },
    UNKNOWN_ERROR: {
      en: 'An unexpected error occurred. Please try again.',
      fr: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
    }
  };

  return new AppError(
    `${code}: ${details instanceof Error ? details.message : String(details)}`,
    code,
    errorMessages[code]
  );
}